import { AxiosResponse } from "axios";
import { TFunction } from "i18next";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { FileUtils } from "../../shared/utils/FileUtils";
import { AdminSubmissionsService } from "../services/AdminSubmissionsService";
import { FormService } from "../../form/services/FormService";

interface Props extends WithTranslation {
}

interface States {
}

class AdminSubmissions extends Component<Props, States> {
  private readonly submissionService: AdminSubmissionsService;
  private t: TFunction;
  private formService: FormService;

  constructor(props: Props) {
    super(props);
    this.submissionService = new AdminSubmissionsService();

    this.t = this.props.t;
    this.formService = new FormService();
  }

  /**
   * On download
   */
  handleDownload() {
    this.submissionService.downloadSubmissions().then((response: AxiosResponse<Blob>) => {
      FileUtils.downloadFile(response);
    });
  }

  render() {
    return (
      <Card title={this.formService.t(this.t, "ui_admin_submissions_title", false)}>
        <Button
          label={this.formService.t(this.t, "ui_admin_submissions_download_button", false)}
          className="p-mb-2"
          onClick={() => this.handleDownload()}
        />
      </Card>
    );
  }
}

export default withTranslation()(AdminSubmissions);
